export const MINIMUM_POLL_VOTES_FOR_DISPLAY = 10;

export const hasSufficientPollData = ({
  up = 0,
  down = 0,
}: {
  up?: number;
  down?: number;
}): boolean => up + down >= MINIMUM_POLL_VOTES_FOR_DISPLAY;
